var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivechatHeadphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 17.5 17.5",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#f5a824",
    stroke: "#f5a824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "livechat_headphone",
    "data-name": "livechat headphone",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-3.339,14.3h0A3.479,3.479,0,0,0,0,10.961V6S-.257,0-5,0s-5,7-5,7",
    transform: "translate(13 0)",
    fill: "none",
    stroke: "#e8994f",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 3,
    height: 5,
    rx: 1.5,
    strokeWidth: 1.5,
    fill: "none",
    stroke: "#e8994f",
    strokeMiterlimit: 10,
    transform: "translate(13 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#e8994f",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1,0A1,1,0,0,0,0,1V2A1,1,0,0,0,1,3H2A1,1,0,0,0,3,2V1A1,1,0,0,0,2,0Z",
    transform: "translate(7 13)",
    fill: "none",
    stroke: "#e8994f",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechatHeadphone);
export default __webpack_public_path__ + "static/media/livechat-headphone.78e99bcfa4ea60fd4a195fb450f76727.svg";
export { ForwardRef as ReactComponent };